import Typography from "@material-ui/core/Typography/index";
import Container from "@material-ui/core/Container/index";
import React from "react";


class GetStartedHeaderWidget extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {appStyle} = this.props;

        return (
            <Container maxWidth="sm" component="main" className={appStyle.getStartedContentHeader}>
                <Typography variant="h3" align="center" color="textPrimary" gutterBottom>
                    Get Started...
                </Typography>
            </Container>
        );
    }
}

export default GetStartedHeaderWidget;